import('./fullscreen.scss')

var FullScreen = L.Control.extend({
    options: {
        position: 'topleft',
        title: 'Full Screen',
        titleCancel: 'Exit Full Screen',
    },

    initialize: function (options) {
        this.options = L.Util.extend({}, this.options, options);
    },

    // _screenfull: fullscreenAPI,

    onAdd(map) {
        let className = 'leaflet-control-zoom-fullscreen';
        let container;
        let content = '';

        if(!this.options.container){
            this.options.container = map._container //tem que ser um element já!! (quem será fullscreenzado)
        }

        if (map.zoomControl) {
            container = map.zoomControl._container;
        }

        this._createButton(this.options.title, className, container, this);
        
        this._map.fullscreenControl = this; //facilitando acesso pelo L.map

        return container;
    },

    onRemove() {
        L.DomEvent
            .off(this.link, 'click', leaflet.DomEvent.stop)
            .off(this.link, 'click', this.toggleFullScreen, this);
    },

    _createButton(title, className, container, context) {
        this.link = L.DomUtil.create('a', className, container);
        this.link.href = '#';
        this.link.title = title;
        this.link.innerHTML = '<i class="fas fa-expand"></i>';

        this.link.setAttribute('role', 'button');
        this.link.setAttribute('aria-label', title);

        L.DomEvent.disableClickPropagation(container);

        L.DomEvent.on(this.link, 'click', L.DomEvent.stop).on(this.link, 'click', this.toggleFullScreen, this)

        return this.link;
    },

    toggleFullScreen(){
        if(!this._isFullScreen()){
            this.options.container.requestFullscreen().then(_=>{
                this.setButtonState()        
            })
        } else {
            document.exitFullscreen().then(_=>{
                this.setButtonState()        
            })
        }

        
    },

    setButtonState(){
        let isFull = this._isFullScreen()
        this.link.title = isFull ? this.options.titleCancel : this.options.title;
        this.link.innerHTML =  isFull ? '<i class="fas fa-compress"></i>' : '<i class="fas fa-expand"></i>';
    },

    _isFullScreen(){
        return document.fullscreenElement === this.options.container
    }

});

L.control.fullscreen = function(options) {
    return new FullScreen(options);
};

